// Feed engagement cards (2026-09-05): battle of the week + challenge of the week.
export const engagement: Record<string, string> = {
  // FeaturedBattleCard
  'Battle of the week': 'Bitka nedelje',
  'Two traders, opposite calls, same chart. Who reaches take-profit first? Vote — the market decides.':
    'Dva trejdera, suprotni pravci, isti grafikon. Ko prvi stiže do take-profita? Glasaj — tržište presuđuje.',
  'The market has spoken. This is how the vote went.': 'Tržište je presudilo. Ovako je glasala zajednica.',
  'Your pick': 'Tvoj izbor',
  'First to TP': 'Prvi do TP',
  'Winner': 'Pobednik',
  'votes': 'glasova',
  'All battles': 'Sve bitke',
  // WeeklyChallengeCard
  'Challenge of the week': 'Izazov nedelje',
  'best R on gold': 'najbolji R na zlatu',
  'days left': 'dana do kraja',
  'until': 'do',
  'Post an XAUUSD signal; the market closes it; the highest realized R by Sunday wins':
    'Objavi XAUUSD signal; tržište ga zatvori; najveći ostvareni R do nedelje osvaja',
  'a month of FX Doctor’s Gold': 'mesec dana FX Doctor’s Gold grupe',
  'No gold signal has been closed by the market this week yet — the first one leads.':
    'Ove nedelje tržište još nije zatvorilo nijedan signal na zlatu — prvi koji se zatvori vodi.',
  'gold signals closed this week': 'signala na zlatu zatvoreno ove nedelje',
  'Enter with a signal': 'Uđi sa signalom',
  '15 minutes 1-on-1 with FX Doctor': '15 minuta 1-na-1 sa FX Doctorom',
  'Last week’s winner': 'Pobednik prošle nedelje',
};
